import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faInstagram,
	faGithub,
	faLinkedin,
	faTwitter,
} from "@fortawesome/free-brands-svg-icons";

export default class Footer extends Component {
	render() {
		const currentYear = new Date().getFullYear();
		return (
			<section className="footer">
				<span style={{ display: "block", marginBottom: "20px" }}>
					Ersoy Efe Uruk | All rights reserved &copy; {currentYear}
				</span>
				<a
					href="https://www.instagram.com/efeuruk/"
					target="_blank"
					rel="noopener noreferrer"
				>
					<FontAwesomeIcon icon={faInstagram} className="icon" />
				</a>
				<a
					href="https://twitter.com/efe_uruk"
					target="_blank"
					rel="noopener noreferrer"
				>
					<FontAwesomeIcon icon={faTwitter} className="icon" />
				</a>
				<a
					href="https://github.com/efeuruk"
					target="_blank"
					rel="noopener noreferrer"
				>
					<FontAwesomeIcon icon={faGithub} className="icon" />
				</a>
				<a
					href="https://www.linkedin.com/in/ersoy-efe-uruk-1b6798130/"
					target="_blank"
					rel="noopener noreferrer"
				>
					<FontAwesomeIcon icon={faLinkedin} className="icon" />
				</a>
			</section>
		);
	}
}
